export const getThumbnailSrc = (src?: string) => {
  if (!src) return undefined;

  const urlBase = src.split('?')[0] ?? src;
  const urlParams = src.split('?')[1] ?? '';

  const newUrlParams = new URLSearchParams(urlParams);

  newUrlParams.set('height', '60');
  newUrlParams.set('width', '60');

  return `${urlBase}?${newUrlParams.toString()}`;
};
